import { useCallback, useMemo } from 'react';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useTheme } from '../../../../../src/theme/useTheme';
import { getWcColors } from '../../../../../components/worldcup/MatchPickStats/matchPickStats.helper';
import { getMatchPickStatsStyles } from '../../../../../components/worldcup/MatchPickStats/MatchPickStatsScreen.styles';
import { MatchPickStatsScreen } from '../../../../../components/worldcup/MatchPickStats/MatchPickStatsScreen';
import { competitionBasePath } from '../../../../../src/competitions/helpers/competitionRoutes.helper';

/**
 * The generic twin of app/app/worldcup/match-stats/[matchId].tsx (AC-10.3).
 * `MatchPickStatsScreen` takes no competition id: it reads the surrounding
 * CompetitionContext, which the competition shell already provides (AC-10.5).
 */
export default function CompetitionMatchStatsRoute() {
  const router = useRouter();
  const theme = useTheme();
  const colors = useMemo(() => getWcColors(theme), [theme]);
  const styles = useMemo(() => getMatchPickStatsStyles(colors), [colors]);
  const { matchId, competitionId: rawCompetitionId } =
    useLocalSearchParams<{ matchId: string; competitionId: string }>();
  const id = typeof matchId === 'string' ? matchId : '';
  const competitionId = rawCompetitionId ?? '';

  // A refresh or a deep link opens this route with no history, and an unconditional
  // back() would leave the button inert. Fall back to this competition's picks tab, which
  // is the tree the card was tapped in — never the World Cup's.
  const handleBack = useCallback(() => {
    if (router.canGoBack()) router.back();
    else router.replace(competitionBasePath(competitionId) as never);
  }, [router, competitionId]);

  return (
    <SafeAreaView style={styles.routeSafeArea} edges={['top', 'left', 'right', 'bottom']}>
      <MatchPickStatsScreen matchId={id} onBack={handleBack} onEditPick={handleBack} />
    </SafeAreaView>
  );
}
